/* Voile des textes en bas d'une photo (rubrique 83 de cn-socle.css) : pour chaque bloc de texte, mesure l'écart entre
   le bas du bloc et le bas de l'image (--cn-voile-bas), pour que le voile finisse au bord bas de l'image. Remesure à
   chaque changement de taille (largeur de l'écran, chargement des polices, ouverture de la recherche). */
(function () {
  var BLOCS = '[id^="cn-hero-"] .cn-inner, [id^="cn-manifesto-"] .cn-inner, [id^="cn-av-"] .cn-av-hero__inner, .image-overlay > .text-overlay--for-banner .text-overlay__text, [id$="__galerie"] .text-overlay__text, .search-recommendations .text-overlay__text';
  var IMAGE = '.cn-slide, [id^="cn-manifesto-"], .cn-av-hero, .image-overlay';

  function regler(bloc) {
    var image = bloc.closest(IMAGE);
    if (!image) return;
    var b = bloc.getBoundingClientRect(), r = image.getBoundingClientRect();
    if (!b.height) return;
    bloc.style.setProperty('--cn-voile-bas', Math.round(r.bottom - b.bottom) + 'px');
  }

  function tout() {
    document.querySelectorAll(BLOCS).forEach(regler);
  }

  function demarrer() {
    tout();
    if (!window.ResizeObserver) { window.addEventListener('resize', tout); return; }
    var ro = new ResizeObserver(tout);
    document.querySelectorAll(BLOCS).forEach(function (bloc) {
      ro.observe(bloc);
      var image = bloc.closest(IMAGE);
      if (image) ro.observe(image);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(tout);
})();
